<app-header>
  <bit-breadcrumbs slot="breadcrumbs">
    <bit-breadcrumb route="../" icon="bwi-sliders">
      {{ "reports" | i18n }}
    </bit-breadcrumb>
    @if (vfo1Enabled()) {
      <bit-breadcrumb [route]="[]">
        {{ reportTitleKey | i18n }}
      </bit-breadcrumb>
    }
  </bit-breadcrumbs>
</app-header>

<bit-container>
  <p>{{ "inactive2faReportDesc" | i18n }}</p>
  @if (!hasLoaded && loading) {
    <div>
      <bit-icon
        name="bwi-spinner"
        class="bwi-spin tw-text-muted"
        [title]="'loading' | i18n"
      ></bit-icon>
      <span class="tw-sr-only">{{ "loading" | i18n }}</span>
    </div>
  } @else {
    <div class="tw-mt-4">
      @if (!ciphers.length) {
        <bit-callout type="success" title="{{ 'goodNews' | i18n }}">
          {{ "noInactive2fa" | i18n }}
        </bit-callout>
      } @else {
        <bit-callout type="danger" title="{{ 'inactive2faFound' | i18n }}">
          {{ "inactive2faFoundReportDesc" | i18n: (ciphers.length | number) : vaultMsg }}
        </bit-callout>
        @if (showFilterToggle && !isAdminConsoleActive) {
          @if (canDisplayToggleGroup()) {
            <bit-toggle-group
              [selected]="filterOrgStatus$ | async"
              (selectedChange)="filterOrgToggle($event)"
              [label]="'addAccessFilter' | i18n"
            >
              @for (status of filterStatus; track status) {
                <bit-toggle [value]="status">
                  {{ getName(status) }}
                  <bit-berry [value]="getCount(status)"></bit-berry>
                </bit-toggle>
              }
            </bit-toggle-group>
          } @else {
            <bit-chip-filter
              [placeholderText]="chipSelectOptions[0].label"
              [options]="chipSelectOptions"
              [ngModel]="selectedFilterChip"
              (ngModelChange)="filterOrgToggleChipSelect($event)"
              fullWidth="true"
            ></bit-chip-filter>
          }
        }
        <bit-table-scroll [dataSource]="dataSource" [rowSize]="75" layout="fixed">
          <ng-container header>
            <th bitCell class="tw-w-12"></th>
            <th bitCell>{{ "name" | i18n }}</th>
            @if (!isAdminConsoleActive) {
              <th bitCell class="tw-w-1/4">{{ "owner" | vfo1I18n: "vault" }}</th>
            }
            <th bitCell class="tw-w-1/4"></th>
          </ng-container>
          <ng-template bitRowDef let-row>
            <td bitCell>
              <app-vault-icon [cipher]="row"></app-vault-icon>
            </td>
            <td bitCell class="tw-truncate tw-max-w-0">
              @if (!organization || canManageCipher(row)) {
                <a
                  bitLink
                  href="#"
                  appStopClick
                  (click)="selectCipher(row)"
                  title="{{ 'editItemWithName' | i18n: row.name }}"
                  >{{ row.name }}</a
                >
              } @else {
                <span title="{{ row.name }}">{{ row.name }}</span>
              }
              @if (!organization && row.organizationId) {
                <bit-icon
                  [name]="'bwi-collection-shared' | vfo1Icon"
                  class="tw-ml-1"
                  appStopProp
                  [title]="'shared' | i18n"
                ></bit-icon>
                <span class="tw-sr-only">{{ "shared" | i18n }}</span>
              }
              @if (row.hasAttachments) {
                <bit-icon
                  name="bwi-paperclip"
                  class="tw-ml-1"
                  appStopProp
                  [title]="'attachments' | i18n"
                ></bit-icon>
                <span class="tw-sr-only">{{ "attachments" | i18n }}</span>
              }
              <br />
              <small>{{ row.subTitle }}</small>
            </td>
            @if (!isAdminConsoleActive) {
              <td bitCell>
                @if (row.organizationId) {
                  <bit-badge variant="secondary">
                    @let orgName = row.organizationId | orgNameFromId: (organizations$ | async);
                    {{ vfo1Enabled() ? ("orgNameVault" | i18n: orgName ?? "") : orgName }}
                  </bit-badge>
                } @else {
                  <bit-badge variant="secondary">
                    {{ "me" | vfo1I18n: "myVault" }}
                  </bit-badge>
                }
              </td>
            }
            <td bitCell class="tw-text-right">
              @if (cipherDocs.has(row.id)) {
                <a
                  bit-chip-action
                  [href]="cipherDocs.get(row.id)"
                  [label]="'instructions' | i18n"
                  target="_blank"
                  rel="noreferrer"
                ></a>
              }
            </td>
          </ng-template>
        </bit-table-scroll>
      }
    </div>
  }
</bit-container>
